import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Circle from "../../../../../src/entities/Circle";
import PointManager from "./PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager";
import SliderManager from "./SliderManager";
import GuideText from "../../../../../src/entities/GuideText";
import TangentTypeCon from "../entities/TangentTypeCon";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import isPortail from "../../../../../src/utils/isPortial";
import { CIRCLE_RADIUS, CENTER_OF_CIRCLE, INITIAL_RADIANS, ARC_COLOR_ARR, INFO_SLIDER_COORD } from "../types/Config";


export default class ComponentManager {
	static instance: ComponentManager;
	Game = Game.getInstance();
	circleRadius = CIRCLE_RADIUS;
	cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);
	PointManager = new PointManager(this.cCoord);
	PointTagManager = new PointTagManager(this.cCoord);
	LineManager = new LineManager(this.cCoord);
	AngleManager = new AngleManager(this.cCoord);
	circle = new Circle(this.cCoord, [...INITIAL_RADIANS, ...INITIAL_RADIANS], ARC_COLOR_ARR);
	guideText = new GuideText(undefined, true);
	InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
	CircleAnimationManager: CircleAnimationManager;
	SliderManager = new SliderManager();
	TangentTypeCon = new TangentTypeCon();

	constructor() {
		this.CircleAnimationManager = new CircleAnimationManager(
			this.PointManager,
			this.AngleManager,
			this.LineManager,
			this.circle,
			this.cCoord
		);
		this.drawElements();

		rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
		eventBus.on(EnumEventBus.setTangentType, () => setTimeout(() => this.drawElements(), 100))
	}
	drawElements() {
		const radians = this.PointManager.getRadians();
		const redPointsCoord = this.PointManager.getRedPointsCoord();
		const tangentPointCoords = this.PointManager.getTangentCoords();
		this.circle.draw({ radians, radius: this.circleRadius });
		this.PointTagManager.updateCoord(radians, this.circleRadius)
		this.LineManager.draw(redPointsCoord, tangentPointCoords);
		this.AngleManager.draw(redPointsCoord, tangentPointCoords);
	}
}